import { useTranslation } from "react-i18next";
import { ScrollToPlansButton } from "@/components/common/ScrollToPlansButton";
import { PurchaseButton } from "@/components/common/PurchaseButton";
import { Context } from "react-helmet-async/lib/Provider";

const VideoFeatures = ({ onPurchase }: { onPurchase: (planId: string) => void }) => {
  const { t } = useTranslation();

  const features = ["step-1", "step-2", "step-3", "step-4"];

  return (
    <section className="py-6 md:py-8 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto">
          <h3 className="text-xl md:text-3xl text-sky-500 mb-2 font-semibold">
            {t('videoFeatures.subtitle')}
          </h3>
          <h2 className="text-3xl mx-8 md:mx-0 md:text-4xl font-semibold text-slate-900 mb-8">
            {t('videoFeatures.title')}
          </h2>
          {(t('videoFeatures.descriptions', { returnObjects: true }) as string[]).map((paragraph, index) => (
            <p key={index} className="text-left text-slate-600 leading-relaxed text-base md:text-lg mb-6 mx-2">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4">
          {features.map((feature, index) => (
            <div
              key={feature}
              className="group rounded-2xl bg-white border border-slate-200 hover:md:border-sky-200 hover:md:shadow-xl transition-all duration-300 transform overflow-hidden"
            >
              <div className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center md:items-stretch`}>
                <div className="w-full md:w-2/5 relative">
                  <div className={`w-full h-full`}>
                    <video
                      className="w-full h-full aspect-[3/4] object-cover"
                      autoPlay
                      loop
                      muted
                      playsInline
                    >
                      <source src={t(`videoFeatures.features.${feature}.videoUrl`)} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="w-full md:w-3/5 space-y-1 px-8 md:px-12 pt-6 pb-8 flex flex-col justify-center">
                  <span className="text-sm md:text-base font-semibold text-sky-500">
                    {t(`videoFeatures.features.${feature}.tag`)}
                  </span>
                  <h3 className="text-2xl md:text-3xl font-semibold text-slate-900">
                    {t(`videoFeatures.features.${feature}.title`)}
                  </h3>

                  <div className="pt-4 space-y-4">
                  {(t(`videoFeatures.features.${feature}.description`, { returnObjects: true }) as string[]).map((paragraph, index) => (
                    <p key={index} className="text-left text-slate-600 leading-relaxed text-base">
                      {paragraph}
                    </p>
                  ))}
                  </div>

                  {(() => {
                    const appendixItems = t(`videoFeatures.features.${feature}.appendix`, { returnObjects: true }) as string[];
                    const hasMultipleColumns = appendixItems.length >= 4;
                    return (
                      <ul className={`list-disc pl-4 text-slate-500 leading-normal text-base pt-2 md:text-sm md:pl-4 marker:text-sky-500 ${hasMultipleColumns ? 'md:columns-2 md:gap-4' : ''}`}>
                        {appendixItems.map((item: string, index: number) => (
                          <li key={index} className="pt-2 break-inside-avoid">{item}</li>
                        ))}
                      </ul>
                    );
                  })()}

                </div>
              </div>

              {/* <div className={`absolute bottom-4 hidden md:block ${index % 2 === 1 ? 'left-6' : 'right-6'}`}>
                <span className="text-7xl font-semibold text-slate-100 group-hover:text-sky-200">
                  {index + 1}
                </span>
              </div> */}
            </div>
          ))}
        </div>
      </div>

      {/* <PurchaseButton onPurchase={onPurchase} /> */}
    </section>
  );
};

export default VideoFeatures;